<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card-gis-filter">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="1">
              <div class="row mt-3">
                <!-- <div class="col-1 text-right">
                  <label for="" style="color:transparent">Todas</label>
                  <el-checkbox
                    label="Todas"
                    v-model="formData.allFarms"
                    @change="allFarmsChange"
                    class="select-primary custom-width-select mt-2"
                  >
                  </el-checkbox>
                </div> -->

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('common_words.farm') }} *</label>
                  <br />
                  <el-select
                    multiple
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-farm shadow-sm"
                    size="large"
                    @change="
                      changeFarm();
                      selectAllFromSelect('formData.farm_id', farms);
                    "
                    v-model="formData.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in farms"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="index + option.id"
                    ></el-option>
                  </el-select>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('common_words.date_range') }}</label>
                  <br />
                  <el-select
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-farm shadow-sm"
                    size="large"
                    v-model="formData.useRange"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in [
                        { name: 'Semanal', id: 1 },
                        { name: 'Intervalo', id: 2 },
                      ]"
                      class="select-primary"
                      :value="option.name"
                      :label="option.name"
                      :key="index + option.id"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                  style=""
                  v-if="formData.useRange == 'Intervalo'"
                >
                  <label for="">{{ $t('common_words.date') }}: </label>
                  <el-date-picker
                    v-if="renderComponent"
                    class="shadow-sm"
                    :clearable="false"
                    v-model="rangeDate"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="-"
                    :start-placeholder="$t('common_words.initial_date')"
                    :end-placeholder="$t('common_words.final_date')"
                    :align="`right`"
                  >
                  </el-date-picker>
                </div>
                <div
                  class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                  style="padding-right: 0"
                  v-if="formData.useRange == 'Semanal'"
                >
                  <label for="">{{ $t('common_words.week') }}: </label>
                  <el-select
                    clearable
                    @clear="formData.year = null"
                    filterable
                    class="select-primary custom-width-select required-year shadow-sm"
                    size="large"
                    v-model="formData.year_sel_init"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in years"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div
                  class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                  style="padding-top: 32px"
                  v-if="
                    formData.year_sel_init && formData.useRange == 'Semanal'
                  "
                >
                  <el-select
                    clearable
                    @clear="formData.week_sel_init = null"
                    filterable
                    class="select-primary custom-width-select required-week shadow-sm"
                    size="large"
                    v-model="formData.week_sel_init"
                  >
                    <el-option
                      v-for="(option, index) in 53"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                  <label>{{ $t('common_words.report_typeof') }} *</label>
                  <br />
                  <el-select
                    clearable
                    v-bind:collapse-tags="true"
                    filterable
                    class="select-primary custom-width-select required-type shadow-sm"
                    size="large"
                    v-model="formData.report_type"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in optionsInterval"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
                <div class="col-12 col-md-4 col-xl-2">
                  <label class="label-primary" style="color: transparent">{{
                    $t('common_words.filter')
                  }}</label
                  ><br />
                  <l-button
                    wide
                    type="info"
                    class="btn-filter"
                    @click="validate"
                  >
                    {{ $t('common_words.filter') }}
                  </l-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
        <div class="row">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="renderComponent"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import moment from 'moment';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Checkbox } from 'element-ui';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      center: {
        lat: 10.947212,
        lng: -74.203901717,
      },
      activeName: '1',
      formData: {
        useRange: 'Semanal',
        year_sel_init: null,
        week_sel_init: null,
        report_type: null,
        farm_id: [],
        // farm_name: [],
        allFarms: false,
      },
      group: [1],
      renderComponent: true,
      reports: null,
      optionsInterval: {
        0: { label: 'Embolse/ha/semana', value: 'pockets' },
        1: { label: 'Cosecha/ha/semana', value: 'cuttings' },
        2: { label: 'Peso promedio fruta', value: 'avg_weight' },
        3: { label: 'Cajas exportadas', value: 'exported_boxes' },
      },
      rangedate: null,
      farms: [],
      years: [],
      mapData: {},
      kmlLayer: null,
      map: null,
      valueCollapse: null,
    };
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    avaliableYears() {
      let currentYear = new Date();
      let previousYear = new Date();

      currentYear = currentYear.getFullYear();
      previousYear = previousYear.getFullYear() - 1;

      return [currentYear, previousYear];
    },
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    MixinDatePicker,
    mixinMasters,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    allFarmsChange() {
      if (this.formData.allFarms) {
        this.formData.farm_id = this.farms.map((farm) => farm.id);
      } else {
        this.formData.farm_id = [];
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      if (this.formData.farm_id.length == 0) {
        return this.validationInputsRequired('farm');
      } else if (
        this.formData.year_sel_init == null &&
        this.formData.useRange == 'Semanal'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.formData.week_sel_init == null &&
        this.formData.useRange == 'Semanal'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.formData.report_type == null) {
        return this.validationInputsRequired('type');
      } else {
        this.loadReport();
      }
    },

    changeFarm() {
      // let farm_names = this.farms.filter((farm) => this.formData.farm_id.includes(farm.id) == true)
      // .map((farm,index) => index == this.formData.farm_id.length - 1 ? `${farm.name}` : `${farm.name}, ` );
      // this.formData.farm_name = farm_names;
      // for (let index = 0; index < this.farms.length; index++) {
      //   if (this.formData.farm_id.includes(this.farms[index].id)) {
      //       if(!this.formData.farm_name.includes(this.farms[index].name)){
      //         this.formData.farm_name.push(this.farms[index].name);
      //       }
      //   }
      // }
    },

    getYears() {
      Axios.getMasters(`gis/production/minyear`)
        .then((response) => {
          this.years = response.data;
        })
        .catch((error) => {
          SweetAlert.warning(i18n.t('sweet_alert.gis.loading_error'));
        });
    },

    loadReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'gis/production/productionmapuniban';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.reports = response.data.data;

            this.loadMap();
          }
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    loadData() {
      let data = {
        farm: this.formData.farm_id,
        // init: parseInt(this.formData.year_sel_init) * 100 + parseInt(this.formData.week_sel_init),
        // end: parseInt(this.formData.year_sel_end) * 100 + parseInt(this.formData.week_sel_end),
        report_type: this.formData.report_type,
        useRange: this.formData.useRange,
      };
      switch (this.formData.useRange) {
        case 'Semanal':
          data.init =
            parseInt(this.formData.year_sel_init) * 100 +
            parseInt(this.formData.week_sel_init);
          // data.end = parseInt(this.formData.year_sel_end) * 100 + parseInt(this.formData.week_sel_end);

          break;
        case 'Intervalo':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');

          break;
      }
      return data;
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    loadMap() {
      this.renderComponent = false;
      this.showHideLoading(true);
      let namesFiles = [];
      let other_values = [];
      // let namesFiles = []
      let centers = [];

      for (let index = 0; index < this.farms.length; index++) {
        if (this.formData.farm_id.includes(this.farms[index].id)) {
          this.center = {
            lat: this.farms[index].latitude,
            lng: this.farms[index].longitude,
          };

          centers.push(this.center);

          if (
            this.farms[index].other_values &&
            JSON.parse(this.farms[index].other_values).files
          ) {
            JSON.parse(this.farms[index].other_values).files.forEach(
              (element) => {
                namesFiles.push(this.farms[index].id + '/' + element);
              }
            );
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        switch (this.formData.report_type) {
          case 'pockets':
            this.loadMapProduction(
              false,
              centers,
              ['Lotes'],
              namesFiles,
              this.reports.reverse(),
              '',
              true
            );
            break;
          case 'cuttings':
            this.loadMapProduction(
              false,
              centers,
              ['Lotes'],
              namesFiles,
              this.reports.reverse(),
              '',
              true
            );
            break;
          case 'avg_weight':
            this.loadMapProduction(
              false,
              centers,
              ['Lotes'],
              namesFiles,
              this.reports.reverse(),
              '',
              true
            );
            break;
          case 'exported_boxes':
            this.loadMapProduction(
              false,
              centers,
              ['Perimetro'],
              namesFiles,
              this.reports.reverse(),
              '',
              true
            );
            break;
          default:
            this.loadMapProduction(
              true,
              centers,
              ['Lotes'],
              namesFiles,
              this.reports,
              null,
              true
            );
            break;
        }

        this.showHideLoading();

        setTimeout(() => {
          document.getElementById('toolbarDiv').style =
            'top: 19% !important;right: 30px;';
        }, 10);
      });
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);

          // if (this.farms.length > 0) {
          //   this.formData.farm_id = this.farms[0].id
          //   this.formData.farm_name = this.farms[0].name
          // }
          this.loadMap();
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          // SweetAlert.warning(error.response.data.message)
        });
    } else {
      this.showHideLoading();
    }

    this.getYears();
    // Axios.getMasters 'calendars/getyearsbusiness').then((response) => {
    // this.years = Object.keys(response.data).reverse();
    // this.showHideLoading()
    // })
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>

<style scoped>
#toolbarDiv {
  top: 12% !important;
  margin-top: 0px;
  padding-top: 0px;
}
</style>
